import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./login.module.css";
import { SelectedInput, SelectedOption } from "../../components/input/SelectedInput";
import axios from "axios";
import MessageDisplay from "../../components/message/MessageDisplay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../utilities/auth/auth";

const LoginForm = () => {
    const { setUser } = useAuth();
    const formRef = useRef();
    const [message, setMessage] = useState(null);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        username: "",
        password: "",
        role: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const isRoleVisible = formData.username.trim() && formData.role.trim();
    const isSubmitEnabled = isRoleVisible && formData.password.trim();

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        console.log(formData, "here to check the user data")
        try {
            const url = `${process.env.REACT_APP_URL}`
            const response = await axios.post(`${url}/auth/login`, formData,
                { withCredentials: true }
            );
            if (response.status === 200) {
                const expiry = Date.now() + 12 * 60 * 60 * 1000;
                localStorage.setItem('sessionExpiry', expiry.toString()); // Store expiry time in localStorage

                console.log(response.data);
                setUser({ username: response.data.username, role: response.data.role, permission: response.data.permission });
                navigate('/dashboard', { replace: true });
            }
        } catch (error) {
            console.error("here is the error", error);
            setMessage({ type: "error", message: error?.response?.data?.errorMessage || "server down" });
        }
    };

    useEffect(() => {
        formRef.current.elements.username.focus();
        const savedTheme = localStorage.getItem("theme") || "light";
        document.documentElement.setAttribute("data-theme", savedTheme);
    }, []);

    return (
        <div className={styles.screen}>
            <h1 className={styles.title}>Uracab</h1>
            <form ref={formRef} onSubmit={handleFormSubmit} className={styles.container}>
                {<MessageDisplay message={message} />}

                <h2 className={styles.wc}>{isRoleVisible ? "Enter your password" : "Welcome Back"}</h2>
                <SelectedInput type="text" name="username" placeholder="Name" value={formData.name} onChange={handleInputChange} lab={true} />
                <SelectedOption
                    name="role"
                    defaultValue="Select your role"
                    options={["Chief Executive Officer", "Chief Technical Officer", "Joint Chief Technical Officer"]}
                    onChange={handleInputChange}
                />
                <div className={`${styles.selectContainer} ${isRoleVisible ? styles.show : styles.hide}`}>
                    <SelectedInput lab={true} type={showPassword ? "text" : "password"} name="password" placeholder="Password*" value={formData.password} onChange={handleInputChange} />
                    <div className={styles.eyeContainer} onClick={togglePasswordVisibility}>
                        <FontAwesomeIcon icon={faEye} className={styles.eye} />
                        {!showPassword && <div className={styles.slash}></div>}  {/* ✅ Add slash only when password is hidden */}
                    </div>
                </div>

                <button type="submit" className={`${styles.loginButton} ${isSubmitEnabled ? styles.show : styles.hide}`} disabled={!isSubmitEnabled}>
                    Login
                </button>
            </form>
        </div>
    );
};

export default LoginForm;
